export const enviroments = {
    // URL_BASE: 'https://backend.shamaimspa.com/public/api/v1',
    //  URL_BASE: 'http://192.168.101.75:3001',
    // URL_BASE: 'http://localhost:3001',
    URL_BASE: 'https://stage.backend.qihotels.net',  
}
